<template>
    <v-card light>
        <v-card-title>
            <v-icon class="mr-3" large :color="iconColor">{{icon}}</v-icon>
            {{`${node.label} Alarms`}}
        </v-card-title>

        

        <v-card-text>
            <div class="alarms-section" :style="{height: `${($props.node.alarms.length * 36) + 50}px`}" v-if="!!$props.node.alarms.length">
                <div id="ag-grid-network-map-alarms-container">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        :gridOptions="gridOptions"
                        :groupHeaders="true"
                        :rowDeselection="true"
                        :rowSelection="'multiple'"
                        @selection-changed="onRowSelectionChanged"
                        @row-double-clicked="details"
                        :rowHeight="36">
                    </ag-grid-vue>
                </div>
            </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>



        <v-dialog v-model="showAlarmDetails" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement">
            <alarm-details v-if="showAlarmDetails" :alarm="selectedRows[0]" @close="showAlarmDetails = false"></alarm-details>
        </v-dialog>

        <v-dialog v-model="showAlarmRemark" max-width="80%" width="550px" persistent :attach="$store.state.fullscreenElement">
            <alarm-remark v-if="showAlarmRemark" @cancel="showAlarmRemark = false" @ok="addRemark"></alarm-remark>
        </v-dialog>

    </v-card>
</template>

<script>
import AlarmDetails from "@/components/Alarms/AlarmDetails";
import AlarmRemark from "@/components/Alarms/AlarmRemark";
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
export default {
    name: 'Alarms',
    props: ['node'],
    components: {
        'ag-grid-vue': AgGridVue,
        AlarmDetails,
        AlarmRemark
    },
    data: () => ({
        showGrid: false,
        gridApi: null,
        gridOptions: {},
        selectedRows: [],
        showAlarmDetails: false,
        showAlarmRemark: false,
    }),

    computed: {
        icon: function() {
            return this.$props.node.network_category_icon ? this.$props.node.network_category_icon : 'mdi-radio-tower';
        },
        iconColor: function() {
            return this.$props.node.network_category_color ? this.$props.node.network_category_color : '#626262';
            //return this.$props.node.network_category_color ? this.$props.node.network_category_color : '#ffffff';
        }
    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.node.alarms;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridApi = self.gridOptions.api;
            }
            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }

            this.gridOptions.popupParent = this.$store.state.fullscreenElement.nodeType ? this.$store.state.fullscreenElement : document.querySelector(this.$store.state.fullscreenElement);
                        
            this.gridOptions.onCellContextMenu = function(params) {
                if(params.node && params.node.group) {
                    self.gridApi.hidePopupMenu();
                    return;
                }
                params.node.setSelected(true, (self.selectedRows.length <= 1));
            }
            this.gridOptions.getContextMenuItems = function(params) {
                return [
                    {
                        name: 'Details',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.details();
                        }
                    },
                    'separator',
                    {
                        name: 'Acknowledge',
                        action: function() {
                            self.acknowledgeClick();
                        }
                    },
                    {
                        name: 'Clear',
                        action: function() {
                            self.clearClick();
                        }
                    },
                    {
                        name: 'Mark as Service Affecting',
                        action: function() {
                            self.markAsServiceAffectingClick();
                        }
                    },
                    'separator',
                    {
                        name: 'Add Remark',
                        action: function() {
                            self.showAlarmRemark = true;
                        }
                    },
                    'separator',
                    {
                        name: 'Un-Acknowledge',
                        action: function() {
                            self.unacknowledgeClick();
                        }
                    },
                    {
                        name: 'Un-Mark as Service Affecting',
                        action: function() {
                            self.unMarkAsServiceAffectingClick();
                        }
                    },
                    'separator',
                    {
                        name: 'Escalate To',
                        subMenu: [
                            {   
                                name: 'Critical',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/critical')),
                                action: function() {
                                    self.escalateToClick('critical');
                                }
                            },
                            {   
                                name: 'Major',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || (self.selectedRows[0].alarm_severity == 'MAJOR') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/major')),
                                action: function() {
                                    self.escalateToClick('major');
                                }
                            },
                            {   
                                name: 'Minor',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || (self.selectedRows[0].alarm_severity == 'MAJOR') || (self.selectedRows[0].alarm_severity == 'MINOR') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/minor')),
                                action: function() {
                                    self.escalateToClick('minor');
                                }
                            }
                        ]
                    },
                    'separator',
                    {
                        name: 'Create Alarm Modification',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createAlarmModification();
                        }
                    },
                    {
                        name: 'Create Paging Rule',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createPagingRule();
                        }
                    },
                    'separator',
                    {
                        name: 'Create Issue',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createIssue();
                        }
                    },
                    {
                        name: 'Site Book',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.siteBook();
                        }
                    },
                    {
                        name: 'Edit Site',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.editSite();
                        }
                    },
                ];
            }

            this.gridOptions.getRowStyle = function(row) {
                let alarmStatus = (row.data.alarm_clear_time.length ? 'cleared' : (row.data.alarm_ack_time.length ? 'acked' : 'new'));

                // If the alarm doesn't have a supported severity then use default(black on white)
                const alarmSeverityTypes = ['OBSERVATIONAL', 'MINOR', 'MAJOR', 'CRITICAL'];
                if(!alarmSeverityTypes.includes(row.data.alarm_severity.toUpperCase())) {
                    return {background: '#ffffff', color: '#000000'};
                }
                return { 
                    background: self.$store.state.batchConfig.webapp_settings.alarms.alarmColors[row.data.alarm_severity.toLowerCase()][alarmStatus].background,
                    color: self.$store.state.batchConfig.webapp_settings.alarms.alarmColors[row.data.alarm_severity.toLowerCase()][alarmStatus].foreground
                }
            }

            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: 'When',
                    suppressSizeToFit: true,
                    field: 'alarm_time',
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    width: 150, 
                    cellStyle: {'padding-top': '4px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Severity',
                    suppressSizeToFit: true,
                    field: 'alarm_severity', 
                    width: 120, filter: 'text', cellStyle: {'padding-top': '4px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Description', 
                    field: 'alarm_description', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '4px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Rep', 
                    suppressSizeToFit: true,
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_repeats ? params.data.alarm_repeats : '');
                    },
                    width: 70, filter: 'text', cellStyle: {'padding-top': '4px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Ack',
                    suppressSizeToFit: true,
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_ack_time.length ? "Yes" : "");
                    },
                    width: 70, filter: 'text', cellStyle: {'padding-top': '4px', 'text-align': 'left'} 
                },
            ];
            return columnDefs;
        },

        onRowSelectionChanged: function() {
            let selectedRows = this.gridOptions.api.getSelectedRows();
            this.selectedRows = selectedRows;
        },

        details: function() {
            let route = (TELSA.apiHost + "alarms/details");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmId: this.selectedRows[0].alarm_id}}).then(response => {
                let result = response.body;
                this.selectedRows[0].details = result;
                this.showAlarmDetails = true;
                TELSA.loading(false);
            });
        },

        acknowledgeClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Acknowledge',
                message: `Are you sure you want to acknowledge ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.acknowledge()
            });
        },
        acknowledge: function() {
            let route = (TELSA.apiHost + "alarms/acknowledge");
            let alarmIDs = this.selectedRows.map(r => r.alarm_id);
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>acknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        clearClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Clear',
                message: `Are you sure you want to clear ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.clear()
            });
        },
        clear: function() {
            let route = (TELSA.apiHost + "alarms/clear");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>clear</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        markAsServiceAffectingClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Mark',
                message: `Are you sure you want to mark ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.markAsServiceAffecting()
            });
        },
        markAsServiceAffecting: function() {
            let route = (TELSA.apiHost + "alarms/serviceaffecting");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>mark service affecting</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        addRemark: function(remarkText) {
            this.showAlarmRemark = false;
            let route = (TELSA.apiHost + "alarms/remark");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows, remark: remarkText}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>add remarks</b> to the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unacknowledgeClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Acknowledge',
                message: `Are you sure you want to un-acknowledge ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unacknowledge()
            });
        },
        unacknowledge: function() {
            let route = (TELSA.apiHost + "alarms/unacknowledge");
            let alarmIDs = this.selectedRows.map(r => r.alarm_id);
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unacknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unMarkAsServiceAffectingClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Mark',
                message: `Are you sure you want to un-mark ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unMarkAsServiceAffecting()
            });
        },
        unMarkAsServiceAffecting: function() {
            let route = (TELSA.apiHost + "alarms/unserviceaffecting");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unmark service affecting</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        escalateToClick: function(level) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Escalate',
                message: `Are you sure you want to escalate ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'} to ${level}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.escalateTo(level)
            });
        },
        escalateTo: function(level) {
            let route = (TELSA.apiHost + "alarms/escalate");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: this.selectedRows[0], escalate: level}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        createAlarmModification: function() {
            this.$store.commit('setAlarmModificationShortcut', this.selectedRows[0]);
            this.$router.push('alarmmodifications');
        },
        createPagingRule: function() {
            this.$store.commit('setPagingRuleShortcut', this.selectedRows[0]);
            this.$router.push('pagingrules');
        },

        createIssue: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return; // if the alarm got cleared while they had it selected then we should stop.
            }
            let route = (TELSA.apiHost + "issues/alarmdetails");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                alarm.alarm_details = result.alarm_details;
                alarm.alarm_site_id = result.alarm_site_id;
                if(this.$store.state.isDirty) {
                    TELSA.loading(false);
                    this.$store.commit('showConfirmModal', {
                        title: 'Are you sure?',
                        message: 'Are you sure you want to abandon your Map Views changes without saving?',
                        type: 'warning',
                        confirmAction: () => {
                            this.$store.commit('setIsDirty', false);
                            this.$store.commit('setCreateIssueFromAlarmShortcut', alarm);
                            this.$router.push('issues');
                        }
                    });
                }
                else {
                    this.$store.commit('setCreateIssueFromAlarmShortcut', alarm);
                    this.$router.push('issues');
                }
            });
        },

        siteBook: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return;
            }
            let route = (TELSA.apiHost + "sites/getsiteid");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                let siteId = result;
                route = (TELSA.apiHost + `sites/site/${siteId}`);
                return this.$http.get(route).then(response => {
                    result = response.body;
                    let site = result.site;
                    if(site.tree_id == -1) {
                        TELSA.loading(false);
                        this.$store.commit('showConfirmModal', {
                            title: 'Site Book Help',
                            message: `The selected site has not been assigned to a tree. You can assign a tree from the 'sites' page`,
                            type: '',
                            hideCancel: true,
                            confirmAction: () => {}
                        });
                    }
                    else {
                        if(this.$store.state.isDirty) {
                            TELSA.loading(false);
                            this.$store.commit('showConfirmModal', {
                                title: 'Are you sure?',
                                message: 'Are you sure you want to abandon your Map Views changes without saving?',
                                type: 'warning',
                                confirmAction: () => {
                                    this.$store.commit('setIsDirty', false);
                                    this.$store.commit('setEditSiteBookFromAlarmShortcut', site);
                                    this.$router.push('sitebook');
                                }
                            });
                        }
                        else {
                            this.$store.commit('setEditSiteBookFromAlarmShortcut', site);
                            this.$router.push('sitebook');
                        }
                    }
                });
            });
        },

        editSite: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return;
            }
            let route = (TELSA.apiHost + "sites/getsiteid");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                alarm.alarm_site_id = result;
                this.goToSite(alarm);
            });
        },

        goToSite: function(alarm) {
            if(this.$store.state.isDirty) {
                TELSA.loading(false);
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your Map Views changes without saving?',
                    type: 'warning',
                    confirmAction: () => {
                        this.$store.commit('setIsDirty', false);
                        this.$store.commit('setEditSiteFromAlarmShortcut', alarm);
                        this.$router.push('sites');
                    }
                });
            }
            else {
                this.$store.commit('setEditSiteFromAlarmShortcut', alarm);
                this.$router.push('sites');
            }
        }

    },

    watch: {
        node: {
            handler(newVal, oldVal) {
                // The alarms data has changed.
                if(this.gridApi) {
                    this.gridApi.setRowData(this.$props.node.alarms);
                }
            },
            deep: true
        }
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style>

    #ag-grid-network-map-alarms-container {
        height: 100%;
    }

    #ag-grid-network-map-alarms-container .ag-row-hover {
        /* putting in !important so it overrides the theme's styling as it hovers the row also */
        background-color: #c8e6c9 !important;
    }

    #ag-grid-network-map-alarms-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

    #telsasoft-application .ag-theme-balham.ag-popup {
        z-index: 1000 !important;
    }

</style>

<style scoped>

    .alarms-section {
        max-height: calc(100vh - 0px);
    }

</style>
